import React, { useEffect, useMemo, useState } from "react";
import Modal from "../../Components/Kanban/Modal/Modal";
import NewSaleForm from "../../Components/OrderForms/NewSaleForm";
import styled from "styled-components";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";
import { MainSectionOfPage } from "../../Components/StyledComponents/FirstSectonOfPages/MainSectionOfPage";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import filterSign from "../../Images/filterSign.svg";
import { useSession } from "../../authentications/SessionContext";
import { orderAction } from "../../Redux/Reducers/OrderSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ReactSelect from "react-select";
import {
  DISPLAY_DATE_FORMAT,
  PAGINATION_DEFAULT_LIMIT,
} from "../../utilities/constants";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { unLink } from "../../DataApi/unlink";
import TableLoader from "../../Components/Loaders/TableLoader";
import { handleResponse } from "../../utilities/handleResponse";
import TableHeader from "../../Components/Table/TableHeader";
import { ORDERS_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import TableBody from "../../Components/Table/TableBody";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import TableToolbar from "../../Components/Table/TableToolbar";
const OrderTypeFilterListOption = [
  { label: "Sales Order", value: JSON.stringify(["sale", "done"]) },
  { label: "My Quotation", value: "" },
  { label: "Quotation Sent", value: JSON.stringify(["sent"]) },
  // { label: "All Orders", value: "" },
];

const OrderSortListOption = [
  { label: "Default", value: "create_date" },
  { label: "Order", value: "name" },
  { label: "Date", value: "date_order" },
  { label: "Customer", value: "partner_id" },
  { label: "Payment", value: "state" },
  { label: "Status", value: "invoice_status_label" },
  { label: "SalesPerson", value: "user_id" },
];
const NewButton = styled.button`
  border-radius: 15px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 20px;
`;

const OrdersContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
`;

const TableData = styled.td`
  cursor: pointer;
  font-weight: 600;
  span:hover {
    text-decoration: underline;
  }
`;
const SearchDiv = styled.form`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  family-font: "Inter";

  input[type="text"] {
    width: 100%;
    padding: 10px;
    padding-left: 40px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    margin-right: 10px;
    background-color: #f8f9fa;
    &:focus {
      border: none;
      outline: none;
    }
  }
  .search-container {
    position: relative;
    width: 100%;
  }
`;
const SearchIcon = styled.span`
  position: absolute; /* Position the icon absolutely */
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  color: #b0b7c3;
  cursor: pointer;
  padding: 12px;
`;

const Orders = () => {
  const { sessionInfo } = useSession();
  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();
  const { company_id, context } = sessionInfo;

  const { ordersList, length, loading } = useSelector((state) => state.order);
  const dispatch = useDispatch();

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [OrderSorting, setOrderSorting] = useState(
    OrderSortListOption[0].value
  );
  const [OrderTypeFilter, setOrderTypeFilter] = useState(
    OrderTypeFilterListOption[0]
  );
  //filter icon toggle in asc r desc direction
  const [filterDirection, setFilterDirection] = useState("desc");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleCreateClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const toggleSelectAll = () => {
    if (selectedRows.length === ordersList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(ordersList.map((record) => record.id));
    }
  };
  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleDeleteSelection = () => {
    setDisableModalButton(true);

    unLink({
      id: [...selectedRows],
      company_id,
      context,
      model: "sale.order",
    }).then((response) => {
      response = JSON.parse(response);
      if (response.result) {
        refetchData();
        setSelectedRows([]);
        setOpenConfirmationModal(false);
      }
      handleResponse({
        response,
        setMetaData,
        setTitle,
        successMessage: "Order Deleted Successfully",
      });
      setDisableModalButton(false);
    });
  };

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleChangeOrderSorting = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handleChangeOrderSortingType = (e) => {
    setOrderSorting(e.target.value);
  };
  const handleChangeOrderTYpeFilter = (value, e) => {
    setOrderTypeFilter(value);
  };

  const handleDeleteOrder = () => {
    setOpenConfirmationModal(true);
    setTitle("");
    setMetaData({
      dangerouslySetInnerHTML: "",
      primaryButton: "Yes",
      secondaryButton: "No",
    });
  };
  const handleEditOrder = (value) => {
    setSelectedOrder(value);
    setIsModalOpen(true);
  };
  const refetchData = () => {
    dispatch(
      orderAction.fetchOrderData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
        },
        search: {
          query: searchQuery,
          type: OrderTypeFilter?.value || "",
        },
        sort: {
          type: OrderSorting || "",
          dir: filterDirection,
        },
      })
    );
  };
  useEffect(() => {
    refetchData();
  }, [
    currentPage,
    searchQuery,
    OrderSorting,
    filterDirection,
    OrderTypeFilter,
  ]);

  const updatedOrdersTableListView = useMemo(() => {
    const updatedList = [...ORDERS_LIST_TABLE_VIEW];
    updatedList.splice(0, 1, {
      ...updatedList[0],
      handleCell: (data, item) => {
        return (
          <input
            type="checkbox"
            checked={
              data
                ? selectedRows.includes(data[item.name])
                : selectedRows.length === ordersList?.length
            }
            onChange={() =>
              data ? toggleSelectRow(data[item.name]) : toggleSelectAll()
            }
          />
        );
      },
    });
    updatedList.splice(1, 1, {
      ...updatedList[1],
      handleCell: (data, item) => (
        <span role="button" onClick={() => handleEditOrder(data.id)}>
          {data[item.name]}
        </span>
      ),
    });
    return updatedList;
  }, [selectedRows, ordersList]);

  return (
    <div>
      <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      />
      <MainSectionOfPage className="d-flex  orders-first-section ">
        <div className="d-none d-md-flex">
          <ReactSelect
            value={OrderTypeFilter}
            options={OrderTypeFilterListOption}
            name="type"
            onChange={handleChangeOrderTYpeFilter}
          />
        </div>
        <div className="btn_and_icons">
          <NewButton onClick={handleCreateClick}>+ {t["Add new"]}</NewButton>

          <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
            <NewSaleForm
              selectedOrder={selectedOrder}
              handleCloseModal={() => {
                handleCloseModal();
                refetchData();
              }}
            />
          </Modal>

          <div className="Filter_icon_div">
            <img
              src={filterSign}
              alt="filter"
              style={{
                transform: `rotate(${
                  filterDirection === "asc" ? "180" : "0"
                }deg)`,
              }}
              onClick={handleChangeOrderSorting}
            />
          </div>
          <div className=" d-none d-md-flex dropdown_list_div d-flex">
            <div className="sort_by">Sort by:</div>
            <select
              className="custom-select"
              onChange={handleChangeOrderSortingType}
              value={OrderSorting}
              name="type"
            >
              {OrderSortListOption.map((option, index) => (
                <option
                  className="select_option"
                  key={index}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </MainSectionOfPage>
      <OrdersContainer>
        <TableContainer>
          <TableToolbar
            handleDelete={handleDeleteOrder}
            handleEditList={handleEditOrder}
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />

          <table className="table">
            <TableHeader tableHeaderList={updatedOrdersTableListView} />
            <TableBody
              tableData={ordersList}
              tableBodyList={updatedOrdersTableListView}
              isLoadingData={loading === "pending" || loading === "idle"}
              checkIsLoadingData
            />
          </table>
          <Pagination
            ListViewData={ordersList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </OrdersContainer>
    </div>
  );
};

export default Orders;
